import { getItems } from 'common/api/systems';

import {
    FETCH_SYSTEM_TYPES,
    FETCH_SYSTEM_TYPES_FAILURE,
    FETCH_SYSTEM_TYPES_SUCCESS,
} from '../actionTypes';
import { createAttachmentModalActions } from '../reducer';

export default () => (dispatch) => {
    dispatch(createAttachmentModalActions[FETCH_SYSTEM_TYPES]());

    getItems()
        .then((response) =>
            dispatch(
                createAttachmentModalActions[FETCH_SYSTEM_TYPES_SUCCESS](
                    response?.data?.data,
                ),
            ),
        )
        .catch((error) =>
            dispatch(
                createAttachmentModalActions[FETCH_SYSTEM_TYPES_FAILURE](error),
            ),
        );
};
